import { AlertTriangle, Info } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type NoticeProps = {
  children: ReactNode;
  /** `warn` for partial / immature / truncated data; `info` for context. */
  tone?: 'warn' | 'info';
  /** Optional trailing action (a Link or Button). */
  action?: ReactNode;
  className?: string;
};

/**
 * One-line disclosure above the content it qualifies (the prototype's
 * cohort notices). Stack several inside <NoticeList>.
 */
export function Notice({ children, tone = 'warn', action, className }: NoticeProps) {
  const Icon = tone === 'warn' ? AlertTriangle : Info;
  return (
    <div role="status" className={cn('flex items-center gap-2.5 py-2 pr-2.5 pl-3.5 text-sm text-muted', className)}>
      <Icon className={cn('size-4 shrink-0', tone === 'warn' ? 'text-warn-ink' : 'text-accent-ink')} aria-hidden="true" />
      <p className="m-0 min-w-0 flex-1">{children}</p>
      {action}
    </div>
  );
}

export function NoticeList({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('flex flex-col divide-y divide-line overflow-hidden rounded-[10px] border border-line bg-head', className)}>
      {children}
    </div>
  );
}
